// ACTIONS
export const TOGGLE_FETCHING = 'offerzen/ui/TOGGLE_FETCHING'

// ACTION CREATORS
export const toggleFetching = (fetching, message) => ({
  type: TOGGLE_FETCHING,
  payload: { fetching, message },
})

// REDUCERS
const initialState = {
  fetching: false,
  message: '',
}

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_FETCHING:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}

export default uiReducer
